export default __webpack_public_path__ + "static/media/8.6c1fd63e.jpg";